import store from '../../store';

export default async (to, from, next) => {

    if (process.env.VUE_ENV === 'development')
        console.log(to.name);

    let pageName = to.name;
    if (pageName === "entities") {
        pageName = "entity";
    } else if (pageName === "view-template") {
        pageName = "template";
    } else if (pageName === "complete-edit-competition") {
        pageName = "competition";
    } else if (pageName === "complete-edit-training") {
        pageName = "training";
    } else if (pageName === "role-indexAdmin") {
        pageName = "role";
    } else if (pageName === "user-superIndex") {
        pageName = "user";
    } else if (pageName === "viewUser-competition") {
        pageName = "competition";
    } else if (pageName === "userView-competition") {
        pageName = "competition";
    } else if (pageName === "userscore-page") {
        pageName = "userscore";
    } else if (pageName === "userscore-pageTeam") {
        pageName = "userscore";
    } else if (pageName === "pageShowUser-userscore") {
        pageName = "userscore";
    } else if (pageName === "pageShowTeams-userscore") {
        pageName = "userscore";
    } else if (pageName === "pageShowUserInTeams-userscore") {
        pageName = "userscore";
    } else if (pageName === "completed-competition") {
        pageName = "competition";
    } else if (pageName === "completedUser-competition") {
        pageName = "competition";
    } else if (pageName === "private-training") {
        pageName = "training";
    } else {
        pageName = to.name;
    }

    if (store.getters['authenticated']) {
        if (store.getters['authenticated'] && store.getters['permissions'].includes('viewAny ' + pageName)) {
            if (to.fullPath === "/settings") {
                next({path: '/settings/user'});
            } else {
                next();
            }
        } else {
            let path = to.fullPath.split('/')[2] ? to.fullPath.split('/')[2] : to.fullPath.split('/')[1];
            await store.dispatch('setErrorModal', true);
            await store.dispatch('setErrorMessage', `You don\'t have permission here to view ${path}`);
            next({path: from.path});
        }
    } else {
        next({name: 'login-page'});
    }
}